import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import type { ProgressOutcomeItem } from "@/domains/progress/models/types";
import {
  buildOutcomeCountQualifier,
  PROGRESS_OUTCOMES_SUB_LINE,
  PROGRESS_OUTCOMES_TITLE,
} from "@/domains/progress/utils/progress-page-copy";
import { Card, Heading } from "@/ui";

const cardLayout = tv({
  base: "flex flex-col gap-4 p-5 sm:p-6",
});

const outcomeTile = tv({
  base: "flex flex-col gap-1 rounded-card border border-line bg-surface-sunken p-4",
});

export type ProgressOutcomesCardProps = ComponentProps<"article"> & {
  items: ProgressOutcomeItem[];
};

export const ProgressOutcomesCard = ({ className, items, ...props }: ProgressOutcomesCardProps) => {
  return (
    <Card className={cardLayout({ className })} {...props}>
      <header className="flex flex-col gap-1">
        <Heading level={2}>{PROGRESS_OUTCOMES_TITLE}</Heading>

        <p className="text-sm text-content-secondary">{PROGRESS_OUTCOMES_SUB_LINE}</p>
      </header>

      <dl className="grid gap-3 sm:grid-cols-2 sm:gap-4">
        {items.map((item) => {
          const qualifier = buildOutcomeCountQualifier(item);

          return (
            <div className={outcomeTile()} key={item.key}>
              <dt className="text-content-secondary">{item.label}</dt>

              <dd className="flex flex-col gap-1">
                <span className="text-3xl font-bold text-content">{item.count}</span>

                {qualifier === null ? null : (
                  <span className="text-sm text-content-secondary">{qualifier}</span>
                )}
              </dd>
            </div>
          );
        })}
      </dl>
    </Card>
  );
};
